import React, { useEffect } from "react";

import { Route, Routes, useNavigate } from "react-router";

import ReceiptScreen from "containers/ReceiptScreen";
import CartContextProvider from "contexts/CartContextProvider";
import useLocale from "hooks/useLocale";
import useMenus from "hooks/useMenus";

import MenuScreenBody from "./MenuScreenBody";

const RedirectToMenu = () => {
	const navigate = useNavigate();
	const { locale } = useLocale();
	const { menus } = useMenus();

	useEffect(() => {
		navigate(`/${locale}/${menus[0].slug}`);
	}, [navigate, locale, menus]);

	return null;
};

const MenuScreen = () => {
	const element = (
		<CartContextProvider>
			<MenuScreenBody />
		</CartContextProvider>
	);

	return (
		<Routes>
			<Route path=":menuSlug/*" element={element} />
			<Route path="receipt/:orderId" element={<ReceiptScreen />} />
			<Route path="//*" element={<RedirectToMenu />} />
		</Routes>
	);
};

export default MenuScreen;
